export interface PurchaseInvoicePackSummaryReport {
  despatchNoteNo: number;
  packNo: string;
  packType: string;
  dimensions: string;
  volume: number;
  grossKgs: number;
  nettKgs: number;
  tareKgs: number;
  noOfItems: number;
}
